var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeft = function SvgLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19 40a1 1 0 0 0 .305.719l30 29a1 1 0 0 0 1.39-1.438L21.439 40l29.256-28.281a1 1 0 0 0-1.39-1.438l-30 29A1 1 0 0 0 19 40",
    clipRule: "evenodd"
  })));
};
export default SvgLeft;